module.exports = __webpack_public_path__ + "assets/cdbc6019f7000793f7c95fb6ca4a38c2.png";